/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */

//libraries
import React, { useState, useEffect, useMemo, useCallback } from 'react';

// custom components
import Article from './components/Article';
import Head from 'components/Head';

// hooks
import { useHistory } from 'react-router-dom';
import useModal from 'hooks/useModal';

// api
import api from './api';

// services
import { convertArticleInfoToViewModel } from './services';

// utils
import { openPromotionalModal } from 'utils/openPromotionalModal';

const ArticleContainer = ({
  match: {
    params: { url },
  },
}: any): JSX.Element => {
  const history = useHistory();

  const { handleModalOpen } = useModal();

  const [articles, setArticles] = useState([]);

  const [articleInfo, setArticleInfo] = useState({
    title: '',
    providerName: '',
    providerSlug: '',
    author: '',
    credentials: [],
    services: [],
    photoUrl: '',
    body: '',
    description: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    (async (): Promise<any> => {
      try {
        const articleInfo = await api.getArticleById(url);

        const convertedArticleInfo = convertArticleInfoToViewModel(articleInfo.data);

        setArticleInfo(convertedArticleInfo);

        const categories = convertedArticleInfo.services.map((service: any) => service.value);

        const articles = await api.getArticles(false, false, categories);

        setArticles(articles.data);
      } catch (err) {
        console.log(err);
      }
      // Show Promotional Modal on page load
      openPromotionalModal(handleModalOpen);
    })();
  }, [url]);

  useEffect(() => {
    if (articleInfo.providerName) {
      // @ts-ignore
      gtag('event', 'Article View', {
        event_category: 'Article',
        event_label: articleInfo.providerName,
      });
    }
  }, [articleInfo]);

  const articlesWithoutCurrent = useMemo(() => articles.filter((article: any) => article.seoUrlStructure !== url), [
    url,
    articles,
  ]);

  const handleRelatedArticleClick = useCallback(
    (url: string) => (): void => {
      history.push(`/learn/${url}`);
    },
    [history],
  );

  const handleShareStoryButtonClick = useCallback((): void => {
    history.push('/share-your-journey');
  }, [history]);

  return (
    articleInfo && (
      <>
        <Head
          title={articleInfo.title}
          slug={`/learn/${url}`}
          description={articleInfo.description}
          ogImageUrl={articleInfo.photoUrl}
        />
        <Article
          articleInfo={articleInfo}
          articles={articlesWithoutCurrent}
          onRelatedArticleClick={handleRelatedArticleClick}
          onShareStoryButtonClick={handleShareStoryButtonClick}
        />
      </>
    )
  );
};

export default ArticleContainer;
